/* ss-bundle-builder — "View all" merchandising order
 *
 * Category tabs already render in their own collection's order, because each tab loops its
 * collection. "View all" did not: it showed every card in tab order, so the grid read as
 * all rugs, then all chairs, then all tables — category clumps rather than merchandising.
 *
 * This reorders the "View all" view to match the Shop All collection. It uses the CSS
 * `order` property rather than moving DOM nodes, so nothing re-renders and the other tabs
 * are untouched.
 */
(function () {
  'use strict';

  function orderMap() {
    var el = document.getElementById('bb-all-order');
    if (!el) return null;
    try {
      var list = JSON.parse(el.textContent) || [];
      var map = {};
      for (var i = 0; i < list.length; i++) map[list[i]] = i;
      return map;
    } catch (e) { return null; }
  }

  function activeTab(bb) {
    var on = bb.querySelector('[data-bb-tab].is-on');
    return on ? on.dataset.bbTab : 'all';
  }

  function apply(bb, map) {
    var isAll = activeTab(bb) === 'all';
    bb.cards.forEach(function (card) {
      // Anything outside the Shop All list sorts to the end rather than jumping the queue.
      card.style.order = isAll ? String(map[card.dataset.handle] != null ? map[card.dataset.handle] : 9999) : '';
    });
  }

  function init(bb) {
    if (!bb || bb._orderReady || !bb.cards || !bb.cards.length) return;
    var map = orderMap();
    if (!map) return;
    bb._orderReady = true;

    apply(bb, map);
    bb.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-bb-tab]')) return;
      // let the builder's own filter run first, then reorder
      setTimeout(function () { apply(bb, map); }, 0);
    });
  }

  function boot() {
    document.querySelectorAll('bundle-builder').forEach(function (bb) {
      if (bb.cards && bb.cards.length) init(bb);
      else setTimeout(function () { init(bb); }, 300);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
